<pbc-filter [config]="BewertungsAnlasssFilterConfig" [filter]="bewertungsAnlasss.filter$ | async" (filterChange)="bewertungsAnlasss.filter$.next($event)"></pbc-filter>
